import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import messages from './messages'
import { useQueryLinkedBankAccounts } from '../../models/useQueryLinkedBankAccounts'

export const useGetLinkedBankAccountsPresenter = ({
  params,
  enabled = true,
}: {
  params?: RepoFilterParams
  enabled?: boolean
} = {}) => {
  const intl = useProcurifyIntl()

  const { linkedBankAccounts, isFetching } = useQueryLinkedBankAccounts({
    params,
    enabled,
    onError: () => {
      toast.error({
        title: intl.formatMessage(
          messages.fetchingLinkedBankAccountsToastError
        ),
      })
    },
  })

  return {
    data: {
      linkedBankAccounts,
    },
    states: {
      isFetching,
    },
  }
}
